import {
  resolveFooterContent,
  pickFooterContent,
  type FooterContent,
} from '../../../utils/footerContent';

/**
 * Rich Atelier footer defaults — shared by the decomposed pure `atelier-band`
 * footer variant. Mirrors AtelierLayout's inline footer defaults + a `theme`
 * block so the standalone band renders the editorial-maison identity (dark
 * canvas + brushed gold) without the sealed layout. Every field is overridable
 * per-tenant via the builder's Footer Content editor (merchant edits win).
 */
export const ATELIER_FOOTER_DEFAULTS: FooterContent = {
  newsletter: {
    enabled: true,
    eyebrow: 'LETTERS FROM THE STUDIO',
    title: 'One letter per chapter — about four a year, never more.',
    subtitle: 'Four letters a year, never more.',
    placeholder: 'Your email address',
    buttonLabel: 'Subscribe',
    successMessage: 'You are on the list. The next chapter will find you.',
  },
  brandBio:
    'A two-room studio off Jalan Bangsar. We make to measure, draft by hand, and ship in natural linen — no plastic, no polybags, no apologies.',
  brandTagline: 'Pieces are made to last a lifetime.',
  brandRegion: 'Made in Malaysia',
  brandAddress: 'Petaling Jaya · Kuala Lumpur',
  brandPhone: '+60 3-TBC 8488 · By appointment',
  brandMark: 'MMXXVI · NO. {year}',
  menuColumns: [
    {
      title: 'The House',
      links: [
        { label: 'Chapter I', url: '/products' },
        { label: 'The Archive', url: '/products' },
        { label: 'By Appointment', url: '/contact' },
        { label: 'Editorial', url: '/blog' },
      ],
    },
    {
      title: 'Maison',
      links: [
        { label: 'Our Story', url: '/about' },
        { label: 'Made in Malaysia', url: '/about' },
        { label: 'Press', url: '/about' },
        { label: 'Contact', url: '/contact' },
      ],
    },
    {
      title: 'Service',
      links: [
        { label: 'Shipping & Returns', url: '/contact' },
        { label: 'Care', url: '/faq' },
        { label: 'Privacy', url: '/privacy' },
        { label: 'Terms', url: '/terms' },
      ],
    },
  ],
  socials: [
    { platform: 'instagram', url: '#instagram' },
    { platform: 'pinterest', url: '#pinterest' },
  ],
  bottomLinks: [],
  copyright: '© {year} {storeName}. ALL RIGHTS RESERVED.',
  theme: {
    bgColor: '#0A0A0A',
    textColor: '#F5F0E8',
    mutedTextColor: '#9E9688',
    accentColor: 'var(--color-primary, #C9A84C)',
    accentLightColor: 'var(--color-accent, #E8D5A3)',
    borderColor: 'rgba(201, 168, 76, 0.22)',
    borderActiveColor: 'rgba(201, 168, 76, 0.55)',
    brandFontFamily: "var(--font-display, 'Playfair Display', 'Cormorant Garamond', Georgia, serif)",
    brandFontStyle: 'italic',
    brandTextTransform: 'none',
    brandLetterSpacing: '0.05em',
    brandFontWeight: 400,
    headingTextTransform: 'uppercase',
    headingLetterSpacing: '0.3em',
    headingFontWeight: 400,
    headingFontSize: '10px',
    linkFontFamily: "var(--font-body, 'Lato', 'Manrope', system-ui, sans-serif)",
    linkFontSize: '13px',
    showNewsletterBand: true,
    showSocials: true,
  },
};

export const buildAtelierFooterContent = (storefrontConfig: any): FooterContent =>
  resolveFooterContent(pickFooterContent(storefrontConfig), ATELIER_FOOTER_DEFAULTS);
